import React from 'react';
import { UIWindowModal } from '../modals';
import { useLang } from '../../../_LangContext';

const ModalSurvey = ({ isOpen, onClose, lang }) => {
    const { getText } = useLang();
    const iframeSrc = `${getText('survey-url')}viewform?embedded=true`;
    
    return (
        <UIWindowModal className="survey" isOpen={isOpen} onClose={onClose}>
			<iframe 
				src={iframeSrc}
				width="100%"
				height="100%"
				frameBorder="0"
				marginHeight="0"
				marginWidth="0"
			>
				Loading...
			</iframe>
        </UIWindowModal>
    );
};

export default ModalSurvey;